import { FC } from 'react';

import { Flow } from 'components/common/flow';
import Image from 'components/common/image';
import ResponsiveBox from 'components/common/responsive-box';
import SiteLink from 'components/common/site-link';

import * as St from './styles';
import { ITileProps } from './types';

export const Tile: FC<ITileProps> = ({
  url,
  image,
  alt,
  title,
  subtitle,
  as,
}) => {
  return (
    <St.Tile as={as}>
      <SiteLink href={url}>
        <ResponsiveBox
          aspectRatio={1}
          as="figure"
          size="tile"
          skeleton={!image}
          rounded
        >
          {!!image && (
            <Image
              loader="imagekit"
              src={image}
              aspectRatio={1}
              sizes="280px"
              loading="lazy"
              objectFit="cover"
              alt={alt || title}
            />
          )}
        </ResponsiveBox>
        <Flow size="3xs">
          <St.TileTitle>{title}</St.TileTitle>
          {subtitle && <span>{subtitle}</span>}
        </Flow>
      </SiteLink>
    </St.Tile>
  );
};
